import { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

const TemplatesListSkeleton = (): ReactNode => (
  <div className="grid h-fit w-full grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-8 xl:grid-cols-3 xl:gap-8">
    <SkeletonItem />
    <SkeletonItem />
    <SkeletonItem />
    <SkeletonItem />
    <SkeletonItem />
    <SkeletonItem />
  </div>
)

const SkeletonItem = (): ReactNode => (
  <div className="flex h-fit flex-col overflow-x-hidden rounded-lg shadow-2">
    <div className="group relative">
      <Skeleton className="h-[200px] rounded-t-md lg:min-w-[300px]" />
    </div>
    <div className="flex flex-col gap-3 px-5 py-6">
      <Skeleton className="h-6 w-full" />
      <ul className="flex flex-wrap gap-1.5">
        <li className="grow">
          <Skeleton className="h-8" />
        </li>
        <li className="grow">
          <Skeleton className="h-8" />
        </li>
        <li className="grow">
          <Skeleton className="h-8" />
        </li>
      </ul>
    </div>
  </div>
)

export default TemplatesListSkeleton
